import { Grid, Select, MenuItem, FormControl } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { megaphone } from 'components/base/images';
import CustomSpan from 'components/common/text/CustomSpan';
import MuiButton from 'components/common/button/MuiButton';
import MuiWrapper from 'components/common/input/MuiWrapper';
import T from 'components/common/text/T';
import { beforeDash, color } from 'styles/utils';
import StorageItemCardList from 'components/store/StorageItemCardList';
import AppItemCardList from 'components/store/AppItemCardList';
import WarrantyItemCardList from 'components/store/WarrantyItemCardList';
import { StyledInShadowButtonOuter } from 'components/common/styled/Button';
import { useShallowAppSelector } from 'store/hooks';
import { StoreActions } from 'store/actionCreators';
import { useDidUpdateEffect } from 'lib/utils';
import useInput from 'lib/hooks/useInput';

interface PaymentProps {
  // paymentUrl?: string;
  // period: object | any;
  // checkedProjectProcess: object | any;
  // keyword: object | any;
}

function PaymentContainer({}: PaymentProps) {
  const { fetchStoreProducts, fetchStoreProductSuccess } = useShallowAppSelector(state => ({
    fetchStoreProducts: state.store.storeProducts.data || {},
    fetchStoreProductSuccess: state.store.storeProducts.success,
  }));
  const history = useHistory();
  // const { webContents } = require('electron');
  const { pathname } = useLocation();
  const lastUrl: string = pathname.split('/').pop();

  const { ipcRenderer }: any = window;

  const testvalue = useInput(false);

  // const channel = new MessageChannel();
  const { port1, port2 } = new MessageChannel();

  useEffect(() => {
    console.log('payment container render ________________________________ ', lastUrl);
  }, []);

  // useEffect(() => {
  //   if (lastUrl === 'cancel') {
  //     console.log('lastUrl ___________________ ', lastUrl);

  //     isModalOpen?.setValue(false);
  //     //127.0.0.1:3000/payment/payletter/return/cancel
  //     // http: isModalOpen?.setValue(false);
  //   }
  // }, [lastUrl]);

  // useDidUpdateEffect(() => {
  //   // PaymentContainer에서 넘어온 postMessgae 처리 부분
  //   // PostMessgae로 넘어온 데이터를 받아서 저장 failure <= cancel, success <= success
  //   window.addEventListener(
  //     'message',
  //     e => {
  //       console.info('postMassage ___ ', e);
  //       // if (
  //       //   e.origin == 'https://www.dofbridge.com' ||
  //       //   e.origin == 'https://dofbridge.com' ||
  //       //   e.origin == 'http://15.164.27.98:28030' ||
  //       //   e.origin == 'http://localhost:3000'
  //       // ) {

  //       // }
  //       console.info('e.data.result ______ ', e.data.result);
  //     },
  //     false,
  //   );
  // }, []);
  const urlPath = 'https://www.dofbridge.com/home';

  // const wind

  useEffect(() => {
    if (ipcRenderer) {
      if (lastUrl === 'cancel') {
        // Main processconst{ port1, port2 }=newMessageChannelMain()webContents.postMessage('port',{ message:'hello'},[port1])
        // Renderer processipcRenderer.on('port',(e, msg)=>{const[port]= e.ports// ...})
        console.log('ipcRenderer _____ ', ipcRenderer);
        console.log('ipcRenderer port1 _____ ', port1);
        // window.postMessage({ result: 'postmsg' }, '*');
        // window.parent.postMessage({ result: 'cancel' }, '*');
        // window.opener.postMessage({ result: 'cancel' }, '*');
        // ipcRenderer.postMessage('syncPortTest', { message: 'cancel' }, [port1]);

        ipcRenderer.send('paymentResponse', { childMessage: 'cancel' });
        // webContents.postMessage({ result: 'cancel' }, '*');
        // ipcRenderer.send('appFocus');
      } else if (lastUrl === 'success') {
        ipcRenderer.send('paymentResponse', { childMessage: 'success' });
      } else if (lastUrl === 'cashreceipt') {
      }
    }
  }, [lastUrl]);

  const testBtn = () => {
    if (ipcRenderer) {
      // ipcRenderer.send('appFocus');
      console.log('ipcRenderer _____ ', ipcRenderer);
    }
  };
  return (
    <StyledPaymentModal data-component-name="PaymentModal">
      <div className="paymentModal__container">
        {lastUrl === 'cancel' && (
          <button className="paymentModal__button" onClick={testBtn}>
            <span>결제 실패</span>
          </button>
        )}
        {lastUrl === 'success' && (
          <div className="paymentModal__button">
            <span>결제 성공</span>
          </div>
        )}
      </div>
    </StyledPaymentModal>
  );
}

const StyledPaymentModal = styled.section<{}>`
  .paymentModal__container {
    background-color: #ffffff;
    width: 420px;
    height: 575px;
    display: flex;
    align-items: center;
    justify-content: center;
    .paymentModal__button {
      height: 50px;
      width: 200px;
      border: 1px solid transparent;
      border-radius: 25px;
      background: linear-gradient(to right, rgba(0, 166, 266, 1), rgba(8, 123, 238, 1));
      color: #ffffff;
      font-size: 15px;
      font-weight: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export default React.memo(PaymentContainer);
